import httpClient from '../httpClient';

export async function getNotaVersao(id: string) {
  try {
    const response = await httpClient.get(`/api/notaversaosisaf/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produto DAF: ' + error);
  }
}

export async function getAllNotasVersao() {
  try {
    const response = await httpClient.get(`/api/notaversaosisaf`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Notas de Versão: ' + error);
  }
}
